export function clientAvatarSrc(client) {
  if (!client) return null;
  return client.logo_url || client.company_logo_url || null;
}

export function assigneeAvatarSrc(assigneeLabel, { participants, user, client, clientContactAvatar } = {}) {
  const label = String(assigneeLabel || "").trim();
  if (!label) return null;
  if (label === "Taī" || label.toLowerCase() === "taistu") {
    return participants?.studio?.avatar_url || user?.avatar_url || null;
  }
  return participants?.client?.avatar_url || clientContactAvatar || clientAvatarSrc(client);
}

export function messageAuthorAvatarSrc(message, { participants, user, client } = {}) {
  if (message?.author_role === "admin") {
    return participants?.studio?.avatar_url || user?.avatar_url || null;
  }
  if (message?.author_role === "client") {
    return (
      participants?.client?.avatar_url
      || participants?.client?.brand_avatar_url
      || clientAvatarSrc(client)
    );
  }
  return null;
}
